import { render, staticRenderFns } from "./BillTable.vue?vue&type=template&id=3dbbae16&scoped=true&"
import script from "./BillTable.vue?vue&type=script&lang=ts&"
export * from "./BillTable.vue?vue&type=script&lang=ts&"
import style0 from "./BillTable.vue?vue&type=style&index=0&id=3dbbae16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbbae16",
  null
  
)

export default component.exports